module.exports = __webpack_public_path__ + "static/img/BM.97f2e093.svg";